/* =========================================================
   FIL & NOUS — Cookie 提示条交互（snippets/fn-cookie-banner.liquid）
   · 每位访客只弹一次：选择后写入 localStorage，并写一份 cookie 兜底（隐私模式下 localStorage 可能不可用）
   · 存的值带版本号（主题设置里的「版本」），改版本号 = 让所有人重新选择一次
   · 只做前端；后端监听 document 的 fn:cookie-consent 事件，或读 window.FNCookieConsent.get()
   ========================================================= */
(function () {
  var el = document.getElementById('fn-cookie');
  if (!el) return;

  var KEY = 'fn_cookie_consent';
  var version = el.dataset.version || '1';

  function read() {
    var raw = null;
    try { raw = localStorage.getItem(KEY); } catch (e) {}
    if (!raw) {
      var m = document.cookie.match(new RegExp('(?:^|; )' + KEY + '=([^;]*)'));
      raw = m ? decodeURIComponent(m[1]) : null;
    }
    if (!raw) return null;
    // 格式：版本|选择|时间戳
    var parts = raw.split('|');
    if (parts[0] !== version || (parts[1] !== 'accept' && parts[1] !== 'decline')) return null;
    return { choice: parts[1], at: Number(parts[2]) || null };
  }

  function save(choice) {
    var raw = version + '|' + choice + '|' + Date.now();
    try { localStorage.setItem(KEY, raw); } catch (e) {}
    document.cookie = KEY + '=' + encodeURIComponent(raw) + '; path=/; max-age=31536000; SameSite=Lax';
  }

  function hide() {
    el.classList.remove('is-in');
    setTimeout(function () { el.hidden = true; }, 350);
  }

  window.FNCookieConsent = {
    get: function () { var r = read(); return r ? r.choice : null; }
  };

  el.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-consent]');
    if (!btn) return;
    var choice = btn.dataset.consent;
    if (!el.hasAttribute('data-preview')) save(choice);
    document.dispatchEvent(new CustomEvent('fn:cookie-consent', { detail: { choice: choice } }));
    hide();
  });

  // 主题编辑器里始终显示；前台已选过就不再弹
  if (!el.hasAttribute('data-preview') && read()) return;
  el.hidden = false;
  requestAnimationFrame(function () {
    requestAnimationFrame(function () { el.classList.add('is-in'); });
  });
})();
